import { FlightRoute, DailyCargoModel, Rac_Validation, ManifestGenerated, Customer, Country, Flight, Provider, Vehicle } from '../webApi/DataModels'
import { each, extend, find } from 'lodash'
import webApi from '@/webApi'
import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'

class DailyCargoState {
    public routes: FlightRoute[] = []
    public routeOptions: any[] = []
    public dailyCargoData:DailyCargoModel[] = []
    public selectedRoute:number = -1
    public manifestGenerated: any[] = []
    public dailyCargoRacNumbers: any[] = []
    public dailyCargoRacValidation: any[] = []
    public dailyCargoDriverData: any[] = []
    public dailyCargoIdentityCheckList: any[] = []
    public dailyCargoDriver: any[] = []
    public dailyCargoDriverById: any = []
    public dailyCargoFlights: any[] = []
}

function resolveValues (ids: number[], values: any[], idFieldName: string, valueFieldName: string, resolvedLabel: string): String {
  var resolvedValues = []
  each(ids, (id) => {
    var filterObject = {}
    filterObject[idFieldName] = id
    var value = find(values, filterObject)
    if (value && value[valueFieldName] && id !== 0) {
      resolvedValues.push(value[valueFieldName])
    }
  })
  if (resolvedValues.length > 4) {
    return resolvedValues.length + ' ' + resolvedLabel
  } else if (resolvedValues.length === 0) {
    return ''
  } else {
    return resolvedValues.join(', ')
  }
}

const mutations = <MutationTree<DailyCargoState>>{
  setRoutes (state: DailyCargoState, routes: FlightRoute[]) {
    state.routes = routes
    state.routeOptions = routes.map((route: FlightRoute) => {
      return {
        value: route.Flight_Route_ID,
        label: route.Origin_Airport_Code + ' - ' + route.Destination_Airport_Code,
        selected: false,
        flightRouteName: route.Flight_Route_Name,
        flightRouteLegOrder: route.Flight_Route_Leg_Order,
        isReturnLeg: route.Is_Return_Leg
      }
    })
    window.sessionStorage.setItem('Flight_List', JSON.stringify(state.routeOptions))
  },
  setDailyCargoData (state: DailyCargoState, dailyCargoData:any[]):void {
    state.dailyCargoData = dailyCargoData
  },
  setDailyCargoRacNumbers (state: DailyCargoState, dailyCargoRacNumbers:any[]):void {
    state.dailyCargoRacNumbers = dailyCargoRacNumbers
  },
  setDailyCargoRacValidation (state: DailyCargoState, dailyCargoRacValidation:any[]):void {
    state.dailyCargoRacValidation = dailyCargoRacValidation
  },
  setDailyCargoDriverData (state: DailyCargoState, dailyCargoDriverData:any[]):void {
    state.dailyCargoDriverData = dailyCargoDriverData
  },
  setDailyCargoIdentityCheckList (state: DailyCargoState, dailyCargoIdentityCheckList:any[]):void {
    state.dailyCargoIdentityCheckList = dailyCargoIdentityCheckList
  },
  setDailyCargoFlights (state: DailyCargoState, { list, flights }: { list:any[], flights: Flight[] }):void {
    each(list, (flightItem: any, index: number) => {
      extend(flightItem, {
        Flight_Name: resolveValues([parseFloat(flightItem.Daily_Cargo_Flight_Routing)], flights, 'value', 'label', 'Flights')
      })

      extend(flightItem, {
        Flight_Route_Name: resolveValues([parseFloat(flightItem.Daily_Cargo_Flight_Routing)], flights, 'value', 'Flight_Route_Name', 'Flights')
      })

      extend(flightItem, {
        Flight_Route_Leg_Order: resolveValues([parseFloat(flightItem.Daily_Cargo_Flight_Routing)], flights, 'value', 'Flight_Route_Leg_Order', 'Flights')
      })
    })
    state.dailyCargoFlights = list
  },
  setDailyCargoDriver (state: DailyCargoState, { list, customers, countries, flights, providers, vehicles }: { list: any, customers: Customer[], countries: Country[], flights: Flight[], providers: Provider[], vehicles: Vehicle[] }) {
    each(list, (driverItem: any, index: number) => {
      var flight = []
      var provider = []
      var vehicle = []
      extend(driverItem, {
        Country_Name: resolveValues(Array.from(driverItem.Country_ID.split(','), Number), countries, 'Country_ID', 'Country_Name', 'Countries')
      })

      extend(driverItem, {
        Customer_Name: resolveValues(Array.from(driverItem.Customer_ID.split(','), Number), customers, 'Customer_ID', 'Customer_Name', 'Customers')
      })

      provider.push(driverItem.Provider_ID)
      extend(driverItem, {
        Provider_Name: resolveValues(provider, providers, 'Provider_ID', 'Provider_Name', 'Providers')
      })

      vehicle.push(driverItem.Vehicle_ID)
      extend(driverItem, {
        Vehicle_Name: resolveValues(vehicle, vehicles, 'Vehicle_ID', 'Vehicle_Type', 'Vehicles')
      })

      flight.push(driverItem.Flight_ID)
      extend(driverItem, {
        Flight_Name: resolveValues(flight, flights, 'value', 'label', 'Flights')
      })
    })

    state.dailyCargoDriver = list
  },
  setDailyCargoDriverById (state: DailyCargoState, dailyCargoDriver:any):void {
    state.dailyCargoDriverById = dailyCargoDriver
  },
  setSelectedRoute (state: DailyCargoState, flightId: number):void {
    state.selectedRoute = flightId
  },
  setManifestGenerated (state: DailyCargoState, generatedManifest:any[]):void {
    state.manifestGenerated = generatedManifest
  },
  reset (state:DailyCargoState) {
    state.routeOptions = []
    state.routes = []
    state.dailyCargoRacNumbers = []
    state.dailyCargoRacValidation = []
    state.dailyCargoDriverData = []
    state.dailyCargoDriver = []
    state.dailyCargoFlights = []
    state.dailyCargoDriverById = []
    state.selectedRoute = -1
    state.manifestGenerated = null
  }
}

const actions = <ActionTree<DailyCargoState, any>>{
  loadFlightRoutes (store: ActionContext<DailyCargoState, any>):Promise<any> {
    if (window.sessionStorage.getItem('Flight_Route_List') != null) {
      // the list has already been stored in session
      store.commit('setRoutes', JSON.parse(window.sessionStorage.getItem('Flight_Route_List')))
      return Promise.resolve('success')
    } else {
      // the list has not been stored in session yet, load from server
      return webApi.daily_cargo.get_Flight_Routes().then(
        (response) => {
          // Store the response
          store.commit('setRoutes', response.data)
          return Promise.resolve('success')
        }).catch((response) => {
        window.bus.$emit('openErrorModal', 'error loading countries: ' + response.ExceptionMessage)
        return Promise.reject(response)
      })
    }
  },
  loadDailyCargoData (store: ActionContext<DailyCargoState, any>, flightId:number): Promise<any> {
    return webApi.daily_cargo.get_Daily_Cargo_Data(flightId).then((response) => {
      var result = response.data
      store.commit('setDailyCargoData', result)
      store.commit('setSelectedRoute', flightId)
      return Promise.resolve('success')
    }).catch((error) => {
      window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
      return Promise.reject(error)
    })
  },
  loadDailyCargoRacNumbers (store: ActionContext<DailyCargoState, any>): Promise<any> {
    return webApi.daily_cargo.get_Daily_Cargo_Rac_Number().then((response) => {
      var result = response.data
      store.commit('setDailyCargoRacNumbers', result)
      return Promise.resolve('success')
    }).catch((error) => {
      window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
      return Promise.reject(error)
    })
  },
  loadGeneratedManifest (store: ActionContext<DailyCargoState, any>): Promise<any> {
    return webApi.daily_cargo.get_Generated_Manifest().then((response) => {
      var result = response.data
      store.commit('setManifestGenerated', result)
      return Promise.resolve('success')
    }).catch((error) => {
      window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
      return Promise.reject(error)
    })
  },
  loadDailyCargoRacValidation (store: ActionContext<DailyCargoState, any>): Promise<any> {
    return webApi.daily_cargo.get_Daily_Cargo_Rac_Validation().then((response) => {
      var result = response.data
      store.commit('setDailyCargoRacValidation', result)
      return Promise.resolve('success')
    }).catch((error) => {
      window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
      return Promise.reject(error)
    })
  },
  loadDailyCargoDriverData (store: ActionContext<DailyCargoState, any>): Promise<any> {
    return webApi.daily_cargo.get_Daily_Cargo_Driver_By_Flight_Id().then((response) => {
      var result = response.data
      store.commit('setDailyCargoDriverData', result)
      return Promise.resolve('success')
    }).catch((error) => {
      window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
      return Promise.reject(error)
    })
  },
  loadDailyCargoIdentityCheckList (store: ActionContext<DailyCargoState, any>): Promise<any> {
    return webApi.daily_cargo.get_Daily_Cargo_Identity_Check_Sheet_List().then((response) => {
      var result = response.data
      store.commit('setDailyCargoIdentityCheckList', result)
      return Promise.resolve('success')
    }).catch((error) => {
      window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
      return Promise.reject(error)
    })
  },
  loadDailyCargoFlights (store: ActionContext<DailyCargoState, any>): Promise<any> {
    return webApi.daily_cargo.get_Daily_Cargo_Flights().then((response) => {
      var result = response.data
      store.commit('setDailyCargoFlights', {
        list: result,
        flights: store.rootState.dailyCargo.routeOptions
      })
      return Promise.resolve('success')
    }).catch((error) => {
      window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
      return Promise.reject(error)
    })
  },
  loadDailyCargoDriver (store: ActionContext<DailyCargoState, any>): Promise<any> {
    return webApi.daily_cargo.get_Daily_Cargo_Driver().then((response) => {
      var result = response.data
      store.commit('setDailyCargoDriver', {
        list: result,
        customers: store.rootState.customer.customers,
        countries: store.rootState.country.countries,
        flights: store.rootState.dailyCargo.routeOptions,
        providers: store.rootState.provider.activeProviders,
        vehicles: store.rootState.vehicle.vehicles,
        preCarriageRoutes: store.rootState.vehicle.preCarriageRoutes
      })
      return Promise.resolve('success')
    }).catch((error) => {
      window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
      return Promise.reject(error)
    })
  },
  loadDailyCargoDriverById (store: ActionContext<DailyCargoState, any>, driver_id: number): Promise<any> {
    return webApi.daily_cargo.get_Daily_Cargo_Driver_By_Id(driver_id).then((response) => {
      var result = response.data
      store.commit('setDailyCargoDriverById', result)
      return Promise.resolve('success')
    }).catch((error) => {
      window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
      return Promise.reject(error)
    })
  },
  saveDailyCargoDriver (store: ActionContext<DailyCargoState, any>, dailyCargoDriverData: any): Promise<any> {
    return webApi.daily_cargo.save_Daily_Cargo_Driver(dailyCargoDriverData).then(
      (response) => {
        return Promise.resolve(response)
      }).catch((response) => {
      window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
      return Promise.reject(response)
    })
  },
  saveDailyCargoFlight (store: ActionContext<DailyCargoState, any>, dailyCargoFlightData: any): Promise<any> {
    return webApi.daily_cargo.save_Daily_Cargo_Flight(dailyCargoFlightData).then(
      (response) => {
        return Promise.resolve(response)
      }).catch((response) => {
      window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
      return Promise.reject(response)
    })
  },
  saveDailyCargoDefaultFlight (store: ActionContext<DailyCargoState, any>, dailyCargoFlightData: any): Promise<any> {
    return webApi.daily_cargo.save_Daily_Cargo_Default_Flight(dailyCargoFlightData).then(
      (response) => {
        return Promise.resolve(response)
      }).catch((response) => {
      window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
      return Promise.reject(response)
    })
  },
  deleteDailyCargoDriver (store: ActionContext<DailyCargoState, any>, dailyCargoDriverData: any): Promise<any> {
    return webApi.daily_cargo.delete_Daily_Cargo_Driver(dailyCargoDriverData).then(
      (response) => {
        store.commit('setDailyCargoDriver', {
          list: store.state.dailyCargoDriver,
          customers: store.rootState.customer.customers,
          countries: store.rootState.country.countries,
          flights: store.rootState.dailyCargo.routeOptions,
          providers: store.rootState.provider.activeProviders,
          vehicles: store.rootState.vehicle.vehicles,
          preCarriageRoutes: store.rootState.vehicle.preCarriageRoutes
        })
        return Promise.resolve(response)
      }).catch((response) => {
      window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
      return Promise.reject(response)
    })
  },
  deleteRacNumber (store: ActionContext<DailyCargoState, any>, racNumber: any): Promise<any> {
    return webApi.daily_cargo.delete_Rac_Number(racNumber).then(
      (response) => {
        return Promise.resolve(response)
      }).catch((response) => {
      window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
      return Promise.reject(response)
    })
  },
  saveDailyCargo (store: ActionContext<DailyCargoState, any>, dailyCargoData: DailyCargoModel): Promise<any> {
    return webApi.daily_cargo.save_Daily_Cargo(dailyCargoData).then(
      (response) => {
        var flight_id = dailyCargoData.Flight_ID
        store.commit('setSelectedRoute', flight_id)
        return Promise.resolve(response)
      }).catch((response) => {
      window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
      return Promise.reject(response)
    })
  },
  saveDailyCargoRACNumber (store: ActionContext<DailyCargoState, any>, dailyCargoRacData: any): Promise<any> {
    return webApi.daily_cargo.save_Daily_Cargo_Rac_Data(dailyCargoRacData).then(
      (response) => {
        return Promise.resolve(response)
      }).catch((response) => {
      window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
      return Promise.reject(response)
    })
  },
  saveDailyCargoSealNumber (store: ActionContext<DailyCargoState, any>, dailyCargoSealData: any): Promise<any> {
    return webApi.daily_cargo.save_Daily_Cargo_Seal_Number(dailyCargoSealData).then(
      (response) => {
        return Promise.resolve(response)
      }).catch((response) => {
      window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
      return Promise.reject(response)
    })
  },
  saveRacValidation (store: ActionContext<DailyCargoState, any>, racValidationData: Rac_Validation): Promise<any> {
    return webApi.daily_cargo.save_Rac_Validation(racValidationData).then(
      (response) => {
        var result = response.data
        store.commit('setDailyCargoRacValidation', result)
        return Promise.resolve(response)
      }).catch((response) => {
      window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
      return Promise.reject(response)
    })
  },
  reset (store: ActionContext<DailyCargoState, any>):void {
    store.commit('reset')
  }
}
const getters = <GetterTree<DailyCargoState, any>> {
  routes: (state) => {
    return state.routes
  },
  routeOptions: (state) => {
    return state.routeOptions
  },
  dailyCargoRacNumbers: (state) => {
    return state.dailyCargoRacNumbers
  },
  dailyCargoRacValidation: (state) => {
    return state.dailyCargoRacValidation
  },
  dailyCargoDriverData: (state) => {
    return state.dailyCargoDriverData
  },
  dailyCargoDriver: (state) => {
    return state.dailyCargoDriver
  },
  dailyCargoDriverById: (state) => {
    return state.dailyCargoDriverById
  },
  dailyCargoFlights: (state) => {
    return state.dailyCargoFlights
  },
  dailyCargoData: (state): any[] => {
    return state.dailyCargoData
  },
  dailyCargoIdentityCheckList: (state): any[] => {
    return state.dailyCargoIdentityCheckList
  },
  selectedRoute: (state): number => {
    return state.selectedRoute
  },
  manifestGenerated: (state): {} => {
    return state.manifestGenerated
  }
}
export default ({
  namespaced: true,
  state: new DailyCargoState(),
  mutations,
  actions,
  getters
})
